import React from 'react';
import useJobs from '../hooks/useJobs';
import Table from '../../common/components/basic/Table';
import { Container } from '../../common/base';
import { css } from 'styled-components';
import Button from '../../common/components/basic/Button';
import styles from '../../common/utils/styles/css/styles';
import Link from 'next/link';
import TouchableItem from '../../common/components/basic/TouchableItem';
import idx from 'idx';
import Desktop from '../../common/utils/styles/css/MediaQuery/Desktop';
import Mobile from '../../common/utils/styles/css/MediaQuery/Mobile';
import LoadingLine from '../../common/components/basic/LoadingLine';
import { useTranslation } from 'react-i18next';

const JobCard = job => (
  <div css={[styles.flexSpaceBetween, styles.pam]}>
    <div>
      <Link href={`/career/${job.id}`}>{job.title}</Link>
    </div>
    <div css={styles.tar}>{idx(job, _ => job.careerlocation.name)}</div>
  </div>
);

export default function Jobs() {
  const { t } = useTranslation();
  const { loading, data: { careerdivisions = [] } = {} } = useJobs();
  const sections = careerdivisions.map(department => ({
    title: department.name,
    data: department.careerjobs.map(job => [
      <Link href={`/career/${job.id}`}>{job.title}</Link>,
      <div>{idx(job, _ => _.careerlocation.name)}</div>,
      <div
        css={[
          styles.flexDirRow,
          css`
            width: 100%;
            justify-content: space-between;
          `
        ]}
      >
        <div>{idx(job, _ => _.careerlevel.name)}</div>
        <Link href={`/career/${job.id}`}>
          <TouchableItem>
            <div
              css={css`
                width: 20px;
                text-align: right;
              `}
            >
              <img width="16" height="16" src="https://image.flaticon.com/icons/svg/32/32213.svg" />
            </div>
          </TouchableItem>
        </Link>
      </div>
    ])
  }));
  return (
    <Container>
      <div
        css={css`
          padding: 80px 0;
        `}
      >
        <h2 css={styles.tac}>Available Positions</h2>
        <Desktop>
          <Table
            loading={loading}
            tableFlexs={[3, 1, 1]}
            headers={['Position', 'Location', 'Level']}
            sections={sections}
          />
        </Desktop>
        <Mobile>
          {loading && (
            <div>
              <LoadingLine />
              <div css={styles.pam}>{t('general.loading', 'Loading')}...</div>
            </div>
          )}
          {!loading &&
            careerdivisions.map(careerdivisions => (
              <div key={careerdivisions.id}>
                <div css={[styles.pam, styles.bggl, styles.fwb]}>{careerdivisions.name}</div>
                {careerdivisions.careerjobs.map(job => (
                  <JobCard {...job} />
                ))}
              </div>
            ))}
        </Mobile>
      </div>
    </Container>
  );
}
